export const coinNames: Record<string, string> = {
    ETH: 'Ethereum',
    BNB: 'Binance Coin',
    XRP: 'XRP',
    DOGE: 'Dogecoin',
    ZRX: '0x',
    OMG: 'OMG Network',
    SNX: 'Synthetix',
    NEAR: 'NEAR Protocol',
    FIL: 'Filecoin',
    GALA: 'Gala',
    ATOM: 'Cosmos',
    EGLD: 'Elrond',
    AXS: 'Axie Infinity',
    ZIL: 'Zilliqa',
    YFI: 'yearn.finance',
    XLM: 'Stellar',
    UNI: 'Uniswap',
    TRX: 'TRON',
    SUSHI: 'SushiSwap',
    SAND: 'The Sandbox',
    MANA: 'Decentraland',
    LINK: 'Chainlink',
    APE: 'ApeSwap Finance',
    AAVE: 'Aave',
    ADA: 'Cardano',
    BAT: 'Basic Attention Token',
    DASH: 'Dash',
    DOT: 'Polkadot',
    EOS: 'EOS',
    GMT: 'Gambit',
    AVAX: 'Avalanche',
    LTC: 'Litecoin',
    BCH: 'Bitcoin Cash',
    COMP: 'Compound',
    '1INCH': '1inch',
    ILV: 'Illuvium',
    PAXG: 'PAX Gold',
    FET: 'Fetch.ai',
    BNT: 'Bancor',
    CAKE: 'PancakeSwap',
    GRT: 'The Graph',
}